import React from 'react'

const Tutorial = () => {
  return (
    <main>
      Tutorial
    </main>
  )
}

export default Tutorial